<template>
  <div class="careers-application-form">
    <div class="row first-row">
      <div class="text-group">
        <h3 class="text-accent">{{ $t('careers-events-1') }}</h3>
        <h1>Формуляр за кандидатстване</h1>
        <h2>
          Представете се и ще се свържем с вас, ако има свободна позиция, подходяща за вас.
          <br />Кандидатствайте като прикачите автобиография, и/или попълните формуляра за кандидатстване.
        </h2>
      </div>
    </div>
    <div class="decoration-element">
      <div class="decoration-element-2"></div>
    </div>
    <div class="form-wrapper">
      <form @submit.prevent="submit()">
        <header>
          <h2>Прикачване на файлове - автобиография, снимки, сканирани документи и др.</h2>
        </header>
        <div class="application-files">
          <label class="files-label" for="applicationFiles">
            <svg
              class="svg-folder"
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="36"
              viewBox="0 0 48 36"
            >
              <path d="M48,164V134H27l-6-6H0v36Z" transform="translate(0 -128)" fill="#ffd869" />
              <path d="M28,128l6,6-6,6H7V128Z" transform="translate(-7 -128)" fill="#d89400" />
            </svg>
            <p>ИЗБЕРЕТЕ ФАЙЛОВЕ</p>
          </label>
          <input type="file" id="applicationFiles" multiple @change="onFilesUpdate($event)" />
          <p
            v-if="!files.length"
          >Може да прикачите до 5 файла (pdf, doc, docx, xls, xlsx, jpg, png), 10 МБ максимално</p>
          <p v-else>{{ files.length }} {{ files.length === 1 ? 'избран файл' : 'избрани файлa' }}</p>
        </div>
        <header>
          <h2>Формуляр за кандидатстване (само полетата, отбелязани с * са задължителни)</h2>
        </header>
        <div class="row">
          <div class="input-wrapper">
            <input
              type="text"
              v-model="application.position"
              placeholder="Позиция, за която се кандидатства"
            />
          </div>
        </div>
        <div class="row">
          <div class="select-wrapper">
            <select v-model="application.company" required>
              <option value selected disabled>Дружество от ХОЛДИНГ КЦМ 2000, в което се кандидатства</option>
              <option value="ХОЛДИНГ КЦМ 2000 АД">ХОЛДИНГ КЦМ 2000 АД</option>
              <option value="КЦМ АД">КЦМ АД</option>
              <option value="КЦМ Трейд ЕООД">КЦМ Трейд ЕООД</option>
              <option value="КЦМ Технолоджи ЕООД">КЦМ Технолоджи ЕООД</option>
              <option
                value="Комплексен индустриален сервиз ЕООД"
              >Комплексен индустриален сервиз ЕООД</option>
              <option value="Металургремонт 21 EАД">Металургремонт 21 EАД</option>
              <option value="Стопански дейности КЦМ ЕООД">Стопански дейности КЦМ ЕООД</option>
              <option value="Стройсервиз ЕООД">Стройсервиз ЕООД</option>
              <option value="Индустриална зона КЦМ ЕООД">Индустриална зона КЦМ ЕООД</option>
              <option value="Лъки Инвест АД">Лъки Инвест АД</option>
              <option value="Върба-Батанци АД">Върба-Батанци АД</option>
              <option value="BLZ Metalikon Ltd">BLZ Metalikon Ltd</option>
              <option value="MCM BV">MCM BV</option>
            </select>
          </div>
        </div>
        <h3 class="h3-category text-color">ЛИЧНИ ДАННИ</h3>
        <div class="row">
          <div class="input-wrapper">
            <input type="text" v-model="application.name" placeholder="*Име, презиме, фамилия" />
          </div>
        </div>
        <div class="row">
          <div class="input-wrapper">
            <input type="text" v-model="application.birthday" placeholder="Дата на раждане" />
          </div>
          <div class="input-wrapper">
            <input type="text" v-model="application.birthplace" placeholder="Място на раждане" />
          </div>
          <div class="select-wrapper">
            <select v-model="application.sex" required>
              <option value selected disabled>Пол</option>
              <option value="жена">жена</option>
              <option value="мъж">мъж</option>
            </select>
          </div>
          <div class="select-wrapper">
            <select v-model="application.status" required>
              <option value selected disabled>Семеен статус</option>
              <option value="неженен/неомъжена">неженен/неомъжена</option>
              <option value="женен/омъжена">женен/омъжена</option>
              <option value="разведен/а">разведен/а</option>
              <option value="вдовец/вдовица">вдовец/вдовица</option>
            </select>
          </div>
        </div>
        <h3 class="h3-category text-color">НАСТОЯЩ АДРЕС</h3>
        <div class="row">
          <div class="input-wrapper">
            <input type="text" v-model="application.city" placeholder="гр.(с.)" />
          </div>
        </div>
        <div class="row">
          <div class="input-wrapper">
            <input type="text" v-model="application.street" placeholder="ул." />
          </div>
        </div>
        <div class="row">
          <div class="input-wrapper">
            <input type="text" v-model="application.entr" placeholder="вх." />
          </div>
          <div class="input-wrapper">
            <input type="text" v-model="application.floor" placeholder="ет." />
          </div>
          <div class="input-wrapper">
            <input type="text" v-model="application.apt" placeholder="ап." />
          </div>
        </div>
        <div class="row">
          <div class="input-wrapper">
            <input type="text" v-model="application.phone" placeholder="телефон" />
          </div>
          <div class="input-wrapper">
            <input type="text" v-model="application.email" placeholder="*e-mail" />
          </div>
        </div>
        <h3 class="h3-category text-color">СРЕДНО ОБРАЗОВАНИЕ</h3>
        <div class="row" v-for="(s, i) in application.school" :key="`school=${i}`">
          <div class="input-wrapper">
            <input type="text" v-model="s.name" placeholder="Учебно заведение" />
          </div>
          <div class="input-wrapper">
            <input type="text" v-model="s.speciality" placeholder="Специалност" />
          </div>
        </div>
        <h3 class="h3-category text-color">ВИСШЕ ОБРАЗОВАНИЕ</h3>
        <div class="row" v-for="(s, i) in application.university" :key="`university=${i}`">
          <div class="input-wrapper">
            <input type="text" v-model="s.name" placeholder="Учебно заведение" />
          </div>
          <div class="input-wrapper">
            <input type="text" v-model="s.speciality" placeholder="Специалност" />
          </div>
          <div class="input-wrapper">
            <input type="text" v-model="s.degree" placeholder="Степен (бакалавър/магистър)" />
          </div>
        </div>
        <h3
          class="h3-category text-color"
        >ДОПЪЛНИТЕЛНИ СПЕЦИАЛИЗАЦИИ, КВАЛИФИКАЦИИ И ПРАВОСПОСОБНОСТ</h3>
        <div class="row" v-for="(s, i) in application.qualifications" :key="`qualifications=${i}`">
          <div class="input-wrapper">
            <input type="text" v-model="s.name" placeholder="Kвалификация" />
          </div>
          <div class="input-wrapper">
            <input type="text" v-model="s.docNum" placeholder="Документ N" />
          </div>
          <div class="input-wrapper">
            <input type="text" v-model="s.issuedBy" placeholder="Издаден от" />
          </div>
        </div>
        <h3 class="h3-category text-color">КОМПЮТЪРНИ УМЕНИЯ</h3>
        <div class="row" v-for="(s, i) in application.computer" :key="`computer=${i}`">
          <div class="input-wrapper">
            <input type="text" v-model="s.product" placeholder="Програмен продукт" />
          </div>
          <div class="input-wrapper">
            <input type="text" v-model="s.level" placeholder="Ниво" />
          </div>
        </div>
        <h3 class="h3-category text-color">ВЛАДЕЕНЕ НА ЧУЖДИ ЕЗИЦИ</h3>
        <div class="row" v-for="(s, i) in application.languages" :key="`languages=${i}`">
          <div class="input-wrapper">
            <input type="text" v-model="s.language" placeholder="Чужд език" />
          </div>
          <div class="input-wrapper">
            <input type="text" v-model="s.level" placeholder="Степен по европейска езикова рамка" />
          </div>
        </div>
        <h3 class="h3-category text-color">ТРУДОВ СТАЖ В ДРУЖЕСТВОТО ОТ ХОЛДИНГ КЦМ 2000</h3>
        <div class="row" v-for="(s, i) in application.experience" :key="`experience=${i}`">
          <div class="select-wrapper">
            <select v-model="s.company" required>
              <option value selected disabled>Дружество</option>
              <option value="ХОЛДИНГ КЦМ 2000 АД">ХОЛДИНГ КЦМ 2000 АД</option>
              <option value="КЦМ АД">КЦМ АД</option>
              <option value="КЦМ Трейд ЕООД">КЦМ Трейд ЕООД</option>
              <option value="КЦМ Технолоджи ЕООД">КЦМ Технолоджи ЕООД</option>
              <option
                value="Комплексен индустриален сервиз ЕООД"
              >Комплексен индустриален сервиз ЕООД</option>
              <option value="Металургремонт 21 EАД">Металургремонт 21 EАД</option>
              <option value="Стопански дейности КЦМ ЕООД">Стопански дейности КЦМ ЕООД</option>
              <option value="Стройсервиз ЕООД">Стройсервиз ЕООД</option>
              <option value="Индустриална зона КЦМ ЕООД">Индустриална зона КЦМ ЕООД</option>
              <option value="Лъки Инвест АД">Лъки Инвест АД</option>
              <option value="Върба-Батанци АД">Върба-Батанци АД</option>
              <option value="BLZ Metalikon Ltd">BLZ Metalikon Ltd</option>
              <option value="MCM BV">MCM BV</option>
            </select>
          </div>
          <div class="input-wrapper">
            <input type="text" v-model="s.position" placeholder="Заемана позиция" />
          </div>
          <div class="input-wrapper">
            <input type="text" v-model="s.experience" placeholder="Стаж (г.м.д.)" />
          </div>
        </div>
        <div class="row form-submit-row">
          <p>
            {{ $t('footer-nav-form-6') }}
            <router-link to="/sustainability?page=gdpr">{{ $t('footer-nav-form-7') }}</router-link>
          </p>
          <div class="captcha-and-submit" v-if="captcha">
            <div class="captcha-wrapper">
              <p
                v-if="captcha.numOne && captcha.numTwo"
              >{{ captcha.numOne }} + {{ captcha.numTwo }} =</p>
              <div class="input-wrapper">
                <input type="text" v-model="application.captchaSum" />
              </div>
            </div>
            <a class="link" @click.prevent="submit()">
              <span class="text-color">{{ $t('send') }}</span>
            </a>
          </div>
        </div>
      </form>
    </div>
    <div
      class="progress"
      :class="{ 'progress-active' : loading }"
      :style="{ 'width' : progress + '%'}"
    ></div>
  </div>
</template>

<script>
import captcha from '../mixins/captcha.js';
export default {
  mixins: [captcha],
  data() {
    return {
      loading: false,
      progress: 0,
      captcha: null,
      files: [],
      application: {
        position: '',
        company: '',
        name: '',
        birthday: '',
        birthplace: '',
        sex: '',
        status: '',
        city: '',
        street: '',
        entr: '',
        floor: '',
        apt: '',
        phone: '',
        email: '',
        school: [{ name: '', speciality: '' }, { name: '', speciality: '' }],
        university: [
          { name: '', speciality: '', degree: '' },
          { name: '', speciality: '', degree: '' },
          { name: '', speciality: '', degree: '' }
        ],
        qualifications: [
          {
            name: '',
            docNum: '',
            issuedBy: ''
          },
          {
            name: '',
            docNum: '',
            issuedBy: ''
          },
          {
            name: '',
            docNum: '',
            issuedBy: ''
          },
          {
            name: '',
            docNum: '',
            issuedBy: ''
          },
          {
            name: '',
            docNum: '',
            issuedBy: ''
          },
          {
            name: '',
            docNum: '',
            issuedBy: ''
          },
          {
            name: '',
            docNum: '',
            issuedBy: ''
          }
        ],
        computer: [
          { product: '', level: '' },
          { product: '', level: '' },
          { product: '', level: '' },
          { product: '', level: '' }
        ],
        languages: [
          { language: '', level: '' },
          { language: '', level: '' },
          { language: '', level: '' },
          { language: '', level: '' }
        ],
        experience: [
          { company: '', position: '', experience: '' },
          { company: '', position: '', experience: '' }
        ],
        captchaSum: null
      }
    };
  },
  watch: {
    '$i18n.locale'() {
      this.checkLang();
    }
  },
  methods: {
    onFilesUpdate(e) {
      let size = 0;
      for (let f of e.target.files) {
        if (
          !f.name.match(
            /\.(jpg|JPG|jpeg|JPEG|png|PNG|pdf|PDF|doc|DOC|docx|DOCX|xls|XLS|xlsx|XLSX)$/
          )
        ) {
          this.$snotify.error(
            'Можете да качвате само файлове с някое от следните разширения - pdf, doc, docx, xls, xlsx, jpg, png'
          );
        }

        size += f.size;
      }

      if (size / 1000 / 1000 > 10) {
        this.$snotify.error(
          'Общият размер на файловете не трябва да надвишава 10 МБ'
        );
        return;
      }

      if (e.target.files.length > 5) {
        this.$snotify.error('Не може да прикачвате повече от 5 файла!');
        return;
      }

      this.files = e.target.files;
    },
    submit() {
      if (this.isValid() && !this.loading) {
        this.loading = true;
        this.progress = 0;

        const fd = new FormData();
        fd.append('data', JSON.stringify(this.application));

        if (this.files.length) {
          for (let i = 0; i < this.files.length; i++) {
            fd.append('files', this.files[i]);
          }
        }

        let url = `${process.env.VUE_APP_BASE_URI}/mail/application`;

        this.$http
          .post(url, fd, {
            onUploadProgress: ue => {
              this.progress = Math.round((ue.loaded / ue.total) * 100);
            }
          })
          .then(() => {
            this.$snotify.success('Формулярът е изпратен успешно!');

            setTimeout(() => {
              this.$router.push('/careers');
            }, 300);
          })
          .catch(err => {
            console.log(err);
            this.$snotify.error('Нещо се обърка, моля опитайте отново.');
          })
          .then(() => {
            setTimeout(() => {
              this.loading = false;
              this.progress = 0;
            }, 1000);
          });
      }
    },
    isValid() {
      if (!this.application.name) {
        this.$snotify.error(this.$t('inquiry-3'));
        return false;
      }
      if (!this.application.email) {
        this.$snotify.error(this.$t('inquiry-5'));
        return false;
      }
      if (!this.application.captchaSum) {
        this.$snotify.error(this.$t('inquiry-10'));
        return false;
      }
      if (this.application.captchaSum) {
        if (+this.captcha.sum !== +this.application.captchaSum) {
          this.$snotify.error(this.$t('inquiry-11'));
          return false;
        }
      }
      return true;
    },
    checkLang() {
      if (this.$i18n.locale !== 'bg') {
        this.$snotify.warning(
          'The application form is available only in Bulgarian.'
        );
        this.$router.push('/careers');
      }
    }
  },
  mounted() {
    this.checkLang();
    this.captcha = this.getCaptcha();

    if (this.$route.query.position) {
      this.application.position = this.$route.query.position;
    }

    if (this.$route.query.company) {
      this.application.company = this.$route.query.company;
    }
  }
};
</script>

<style lang="scss" scoped>
.careers-application-form {
  padding-bottom: 50px;
  position: relative;
  .first-row {
    padding: 50px $sidesPadding 0;
  }
}
.form-wrapper {
  padding-right: $sidesPadding + $chemicalLarge + ($sidesPadding / 2);
  padding-left: $sidesPadding + $chemicalLarge + ($sidesPadding / 2);
  header {
    @extend %flex-center;
    background-color: $mainColor;
    color: #fff;
    height: 44px;
    justify-content: space-between;
    margin: 20px 0 10px;
    padding: 0 15px;
    @include transition(all 0.3s);
    p {
      font-weight: 500;
    }
  }
  .application-files {
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .files-label {
    align-items: center;
    background-color: #0668ae;
    cursor: pointer;
    display: flex;
    margin-right: 10px;
    padding: 10px 15px;
    @include transition(all 0.3s);
    .svg-folder {
      height: 36px;
      margin-right: 10px;
      width: 48px;
    }
    p {
      color: #fff;
      font-weight: 500;
    }

    &:hover {
      background-color: #2aacef;
    }

    & ~ input[type='file'] {
      height: 0.1px;
      opacity: 0;
      overflow: hidden;
      position: absolute;
      width: 0.1px;
      z-index: -1;
    }
  }
  .row {
    & > * {
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .form-submit-row {
    align-items: center;
    justify-content: space-between;
    margin-top: 30px;
    p {
      font-size: 10px;
      line-height: 12px;
      width: 45%;
      a {
        text-decoration: underline;
      }
      a:hover {
        opacity: 0.8;
      }
    }
    .captcha-and-submit {
      display: flex;
      .captcha-wrapper {
        p {
          margin: 0;
        }
      }
    }
    .link::before {
      background-color: $accentColor;
    }
  }

  input::placeholder {
    color: rgba($color: #000, $alpha: 0.5);
  }
  input::-webkit-input-placeholder {
    color: rgba($color: #000, $alpha: 0.5);
  }
  input:-ms-input-placeholder {
    color: rgba($color: #000, $alpha: 0.5);
  }
  input::-moz-placeholder {
    color: rgba($color: #000, $alpha: 0.5);
  }
  input:-moz-placeholder {
    color: rgba($color: #000, $alpha: 0.5);
  }
  select:invalid {
    color: gray;
  }
  select option:not([disabled]) {
    color: #000;
  }
}
.h3-category {
  text-align: center;
  margin: 30px 0 15px;
}
.progress {
  background-color: $accentColor;
  display: block;
  height: 5px;
  left: 0;
  opacity: 0;
  position: fixed;
  top: 0;
  z-index: 10;
  @include transition(width 0.3s);
}
.progress-active {
  opacity: 1;
}
@media screen and (max-width: 1600px) {
  .careers-application-form {
    .first-row {
      padding: 50px $sidesPadding1600 0;
    }
  }
  .form-wrapper {
    padding-right: $sidesPadding1600 + $chemicalLarge + ($sidesPadding1600 / 2);
    padding-left: $sidesPadding1600 + $chemicalLarge + ($sidesPadding1600 / 2);
  }
}
@media screen and (max-width: 1440px) {
  .form-wrapper {
    padding-right: $sidesPadding1600 + $chemicalLarge1440 +
      ($sidesPadding1600 / 2);
    padding-left: $sidesPadding1600 + $chemicalLarge1440 +
      ($sidesPadding1600 / 2);
    header {
      p {
        font-size: 13px;
      }
    }
  }
}
@media screen and (max-width: 1280px) {
  .careers-application-form {
    padding-bottom: 40px;
    .first-row {
      padding: 40px $sidesPadding1280 20px;
    }
  }
  .form-wrapper {
    padding-right: $sidesPadding1280 + $chemicalLarge1440 +
      ($sidesPadding1280 / 2);
    padding-left: $sidesPadding1280 + $chemicalLarge1440 +
      ($sidesPadding1280 / 2);
  }
}
@media screen and (max-width: 1000px) {
  // .careers-application-form {
  // }
  .form-wrapper {
    padding-right: $sidesPadding1280;
    padding-left: $sidesPadding1280;
    header {
      p {
        font-size: 12px;
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .careers-application-form {
    padding-bottom: $sidesPadding600;
    .first-row {
      padding: $sidesPadding600;
    }
  }
  .form-wrapper {
    padding-right: $sidesPadding600;
    padding-left: $sidesPadding600;
    header {
      margin: 10px 0;
      padding: 0 10px;
    }
    .files-label {
      padding: 10px;
      .svg-folder {
        height: 24px;
        width: 32px;
      }
      p {
        font-size: 10px;
      }
    }
    .form-submit-row {
      flex-direction: column;
      > p {
        margin-bottom: 15px;
        text-align: center;
        width: 100%;
      }
    }
  }
  .row {
    flex-direction: column;
  }
}
@media screen and (max-width: 420px) {
  .form-wrapper {
    .form-submit-row {
      flex-direction: column;
      margin: 10px;
      p {
        width: 100%;
        margin-bottom: 20px;
      }
    }
  }
}
</style>
